function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#2D2D2D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.878 2.024a.854.854 0 00-.854.854v6.83c0 .47.383.853.854.853h4.44a.512.512 0 110 1.024h-4.44A1.878 1.878 0 011 9.707V2.878C1 1.841 1.84 1 2.878 1h4.098c.135 0 .266.054.362.15l1.216 1.216h3.885c1.037 0 1.878.84 1.878 1.878v4.78a.512.512 0 11-1.024 0v-4.78a.854.854 0 00-.854-.854H8.341a.512.512 0 01-.362-.15L6.763 2.024H2.878z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.073 8.17a2.902 2.902 0 100 5.806 2.902 2.902 0 000-5.805zm-3.927 2.903a3.927 3.927 0 117.854 0 3.927 3.927 0 01-7.854 0zm3.927-1.878c.283 0 .512.23.512.512v1.154l.875.874a.512.512 0 11-.725.725l-1.024-1.025a.512.512 0 01-.15-.362V9.707c0-.283.23-.512.512-.512z"
}));
function SvgHistorial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Historial.svg";
export { SvgHistorial as ReactComponent };